import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext.jsx';
import Layout from './components/Layout.jsx';
import LoginPage from './pages/LoginPage.jsx';
import TenantsPage from './pages/tenants/TenantsPage.jsx';
import UsersPage from './pages/users/UsersPage.jsx';
import ClientsPage from './pages/clients/ClientsPage.jsx';
import ClientDetailPage from './pages/clients/ClientDetailPage.jsx';
import AirportsPage from './pages/airports/AirportsPage.jsx';
import SeaportsPage from './pages/seaports/SeaportsPage.jsx';
import IncotermsPage from './pages/parametrizacion/incoterms/IncotermsPage.jsx';
import CommodityTypesPage from './pages/parametrizacion/commodity-types/CommodityTypesPage.jsx';
import ChargeConceptsPage from './pages/parametrizacion/charge-concepts/ChargeConceptsPage.jsx';
import DocumentTypesPage from './pages/parametrizacion/document-types/DocumentTypesPage.jsx';
import SuppliersPage from './pages/parametrizacion/suppliers/SuppliersPage.jsx';
import GeneralSettingsPage from './pages/parametrizacion/general-settings/GeneralSettingsPage.jsx';
import RequestsPage from './pages/air-requests/RequestsPage.jsx';
import ModulosPage from './pages/modulos/ModulosPage.jsx';
import QuotationsBoardPage from './pages/air-requests/boards/QuotationsBoardPage.jsx';
import InProgressBoardPage from './pages/air-requests/boards/InProgressBoardPage.jsx';
import CompletedBoardPage from './pages/air-requests/boards/CompletedBoardPage.jsx';
import RejectedBoardPage from './pages/air-requests/boards/RejectedBoardPage.jsx';
import LclRequestsPage from './pages/lcl-requests/LclRequestsPage.jsx';
import LclQuotationsBoardPage from './pages/lcl-requests/boards/LclQuotationsBoardPage.jsx';
import LclInProgressBoardPage from './pages/lcl-requests/boards/LclInProgressBoardPage.jsx';
import LclCompletedBoardPage from './pages/lcl-requests/boards/LclCompletedBoardPage.jsx';
import LclRejectedBoardPage from './pages/lcl-requests/boards/LclRejectedBoardPage.jsx';
import TraceabilityPublicPage from './pages/traceability/TraceabilityPublicPage.jsx';

function Protected({ children, requirePlatform, requireTenant }) {
  const { user, isPlatformMode } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (requirePlatform && !isPlatformMode) {
    return <Navigate to="/users" replace />;
  }
  if (requireTenant && isPlatformMode) {
    return <Navigate to="/users" replace />;
  }
  return children;
}

function DefaultLanding() {
  const { user, isPlatformMode } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={isPlatformMode ? '/tenants' : '/users'} replace />;
}

export default function App() {
  return (
    <Routes>
      {/* Rutas públicas (sin auth) */}
      <Route path="/t/:operador/:numero" element={<TraceabilityPublicPage />} />
      <Route path="/t/:numero" element={<TraceabilityPublicPage />} />

      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route
          path="/tenants"
          element={
            <Protected requirePlatform>
              <TenantsPage />
            </Protected>
          }
        />
        <Route
          path="/clients"
          element={
            <Protected requireTenant>
              <ClientsPage />
            </Protected>
          }
        />
        <Route
          path="/clients/:id"
          element={
            <Protected requireTenant>
              <ClientDetailPage />
            </Protected>
          }
        />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/airports" element={<AirportsPage />} />
        <Route path="/seaports" element={<SeaportsPage />} />
        <Route path="/incoterms" element={<IncotermsPage />} />
        <Route path="/commodity-types" element={<CommodityTypesPage />} />
        <Route path="/parametrizacion/conceptos" element={<ChargeConceptsPage />} />
        <Route path="/document-types" element={<DocumentTypesPage />} />
        <Route path="/parametrizacion/proveedores" element={<SuppliersPage />} />
        <Route path="/suppliers" element={<SuppliersPage />} />
        <Route path="/general-settings" element={<GeneralSettingsPage />} />
        <Route path="/requests" element={<RequestsPage />} />
        <Route path="/requests/board/cotizaciones" element={<QuotationsBoardPage />} />
        <Route path="/requests/board/en-curso" element={<InProgressBoardPage />} />
        <Route path="/requests/board/finalizadas" element={<CompletedBoardPage />} />
        <Route path="/requests/board/rechazadas" element={<RejectedBoardPage />} />

        {/* Módulo LCL (carga marítima consolidada) — solo tenants */}
        <Route
          path="/lcl"
          element={
            <Protected requireTenant>
              <LclRequestsPage />
            </Protected>
          }
        />
        <Route
          path="/lcl/board/cotizaciones"
          element={
            <Protected requireTenant>
              <LclQuotationsBoardPage />
            </Protected>
          }
        />
        <Route
          path="/lcl/board/en-curso"
          element={
            <Protected requireTenant>
              <LclInProgressBoardPage />
            </Protected>
          }
        />
        <Route
          path="/lcl/board/finalizadas"
          element={
            <Protected requireTenant>
              <LclCompletedBoardPage />
            </Protected>
          }
        />
        <Route
          path="/lcl/board/rechazadas"
          element={
            <Protected requireTenant>
              <LclRejectedBoardPage />
            </Protected>
          }
        />
        <Route
          path="/modulos"
          element={
            <Protected requireTenant>
              <ModulosPage />
            </Protected>
          }
        />
        <Route path="/" element={<DefaultLanding />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
